import { render } from "./ContactTrad.vue?vue&type=template&id=2c88e7a9"
import script from "./ContactTrad.vue?vue&type=script&lang=js"
export * from "./ContactTrad.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jaxz/Desktop/wangyan-campaign/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__